import { createSlice } from '@reduxjs/toolkit';
// utils
import axiosIntanceAccessZalo from '../../helper/axiosIntanceAccessZalo';
import apiWidget from '../../api/widget';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
    return array.reduce((accumulator, current) => {
        accumulator[current[key]] = current;
        return accumulator;
    }, {});
}

const initialState = {
    queue_live: [],
    is_status_connect: false

};
//
// name : teen store quan li
const slice = createSlice({
    name: 'widget',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        statusEventGuestToUser(state, action) {
            const participants = action.payload;
            state.queue_live.push({socket_id: participants.socket_id, welcome_message:participants.welcome_message});
            state.is_status_connect = true;
        },
        statusAcceptConnect(state, action) {
            const participants = action.payload;
            //lấy phần tử cuôi cùng trong mảng
            let lastElement = state.queue_live.slice(-1)[0];
            state.queue_live.pop();
            if (state.queue_live.length == 0) {
                state.is_status_connect = false;
            }

        },
        statusAcceptAllConnect(state, action) {
            const participants = action.payload;
            //lấy phần tử cuôi cùng trong mảng
            state.queue_live = [];
            state.is_status_connect = false;

        },
        statusRejectConnect(state, action) {
            const participants = action.payload;
            let lastElement = state.queue_live.slice(-1)[0];
            state.queue_live.pop();
            if (state.queue_live.length == 0) {
                state.is_status_connect = false;
            }
        }, 
        statusSendMessageSuccess(state, action) {
            const participants = action.payload;
            state.isLoading = false;
        },
        statusRemoveQueue(state, action) {
            const participants = action.payload;
            state.queue_live = state.queue_live.filter(item => item.socket_id !== participants.socket_id);
            if (state.queue_live.length == 0) {
                state.is_status_connect = false;
            }
        },


    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function sendMessageForPlugin(params) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await apiWidget.send_message(params);
            params.message_id = response.data.data.message_id;
            if (response.data.data.attachment_url_image) {
                params.attachment_url_image = response.data.data.attachment_url_image;
            }
            if (response.data.data.message_id) {
                dispatch(slice.actions.statusSendMessageSuccess(params));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function onEventGuestConnectUser(params) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.statusEventGuestToUser(params));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function onAcceptConnect(params) {
    return async (dispatch) => {
        try {
            const res_accept_connect = apiWidget.accept_connect({ socket_ids: params })
            dispatch(slice.actions.statusAcceptConnect());
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function onRemoveQueue(params) {
    return async (dispatch) => {
        try {

            dispatch(slice.actions.statusRemoveQueue(params));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function onAcceptAllConnect(params) {
    return async (dispatch) => {
        try {
            const res_accept_connect = apiWidget.accept_connect({ socket_ids: params })
            dispatch(slice.actions.statusAcceptAllConnect());
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function onRejectConnect(params) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.statusAcceptConnect(params));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
